import {toggleAreaExpend} from "./inputs";
import {setCookie, readCookie, getDaysTimout} from "../utils/cookie";


//Gesture of Toggled Menu with cookie
const years = 60*60*24*365;
const days = 60*60*24;
const cookieToggleMenu = "toggle_menu";

let cookie = readCookie(cookieToggleMenu)
if (!cookie) {
    setCookie(cookieToggleMenu, 1, getDaysTimout(days*7));
} else {
    toggleNavigationMenu(cookie)
}


export function menuIsToggled() {
    return ($("body").hasClass('active-menu')) ? 1 : 0;
}

export function toggleNavigationMenu(show = null) {
    if (!menuIsToggled() || show == 1) {
        $("body").addClass('active-menu')
        $("#main-navigation").attr("aria-expanded", 'true')
    } else {
        //Annimation navigation
        $("body").removeClass('active-menu')
        $("#main-navigation").attr("aria-expanded", 'false')
    }

    //Annimation content
    $("#main-content").css('width', "unset")
    setTimeout(() => updateContentWidth(), 600)

    //Set Cookie
    let toggled = ($("body").hasClass('active-menu')) ? 1 : 0
    setCookie(cookieToggleMenu, toggled, getDaysTimout(days*7));
}

export function updateContentWidth() {
    let contentWidth = $(window).width() - $('#main-navigation').width()
    $("#main-content").width(contentWidth)
}


updateContentWidth()
setInterval(() => updateContentWidth(), 1)
$(window).resize(() => {
    updateContentWidth()
    setTimeout(() => updateContentWidth(), 350)
    setTimeout(() => updateContentWidth(), 450)
})

$("#toggle-main-navigation").click(function () {
    toggleNavigationMenu()
})

//Mobile search menu
$("#open-search-mobile").click(function () {
    $('.search-box').slideDown();
})
$('#close-search-mobile').click(function () {
    $('.search-box').slideUp();
})

//Navigation menu on mobile
$(function(){
    $("body").addClass("show-mobile-navigation")
    let lastScrollTop = 0;
    $(window).scroll(function(){
        var st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > lastScrollTop) {
            // downscroll code
            $("body").removeClass("show-mobile-navigation")
        } else {
            // upscroll code
            $("body").addClass("show-mobile-navigation")
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    });
});

//Back top top button
updateBackToTopButton()
window.onscroll = function () {
    updateBackToTopButton()
};
function updateBackToTopButton() {
    if (window.pageYOffset > window.innerHeight * 0.75) {
        $("#back_to_top").css('display', 'flex')
        $("#back_to_top").attr('tabindex', '0')
    } else {
        $("#back_to_top").css('display', 'none')
        $("#back_to_top").attr('tabindex', '-1')
    }
}
$("#back_to_top").click(function () {
    window.scrollTo({top: 0, behavior: 'smooth'})
}).keypress(function (e) {
    if(e.which === 13) {
        window.scrollTo({top: 0, behavior: 'smooth'})
    }
})


// $(document).click(function () {
//     let test = $(this).parents('#main-navigation').length
//     console.log(test)
//     if (!$(this).parents('#main-navigation').length) {
//         toggleAreaExpend($("#main-navigation"))
//     }
// })
